// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3raIG","image":"Header_image__2i94P","name":"Header_name__20Xxo","info":"Header_info__27iDn","infoRow":"Header_infoRow__qbatr"};